import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
  const routes = [
    {
      path: "/",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      path: "/home",
      name: "Home",
      component: () =>
        import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      children: [
        {
          //Vista donde estan los graficos
          path: "/areas",
          component: () =>
            import(/* webpackChunkName: "Dash" */ "../views/Areas.vue"),
        },
        {
          //Demo carpeta Storage
          path: "/storage",
          component: () =>
            import(
              /* webpackChunkName: "Instituciones" */ "../views/storage/index.vue"
            ),
        },
        {
          //Dashboard
          path: "/dashboard",
          component: () =>
            import(
              /* webpackChunkName: "Dashboard" */ "../views/Dashboard.vue"
            ),
        },
        {
          //Master de Reportes
          path: "/reportes",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/Reportes.vue"
            ),
        },

        {
          //Master de Reportes
          path: "/solicitud-materiales",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/solicitud-materiales/listado-solicitud.vue"
            ),
        },
        {
          //Master de Reportes
          path: "/formulario-dinamico",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/formulario-dinamico/formulario-dinamico.vue"
            ),
        },
        {
          //Módulo de tickets
          path: "/tickets",
          component: () =>
            import(
              /* webpackChunkName: "Tickets" */ "../views/tickets/listado-tickets.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/programas-aseo",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/programas-aseo/listado-programas.vue"
            ),
        },
        {
          //Programas de aseo
          path: "/almacenamiento-archivo",
          component: () =>
            import(
              /* webpackChunkName: "Programas de Aseo" */ "../views/almacenamiento-archivo/almacenamiento-archivo.vue"
            ),
        },
        {
          //Master de Reportes
          path: "/crear-formulario",
          component: () =>
            import(
              /* webpackChunkName: "Evaluacion" */ "../views/formulario-dinamico/crear-formulario.vue"
            ),
        },
        {
          //Vista donde estan los graficos
          path: "/usuarios",
          component: () =>
            import(/* webpackChunkName: "Dash" */ "../views/SysUser.vue"),
        },
      ],
    },
    {
      path: "/login",
      name: "Log",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
  ];

const router = new VueRouter({
  routes
})

export default router
